export const config = process.env.NODE_ENV === "development" ? {
  apiKey: "AIzaSyBP4Uo67HFV33eZlKyz6H6sfCIjCernIK8",
  authDomain: "smart-inventory-1f586.firebaseapp.com",
  databaseURL: "https://smart-inventory-1f586.firebaseio.com",
  projectId: "smart-inventory-1f586",
  storageBucket: "smart-inventory-1f586.appspot.com",
  messagingSenderId: "801243583431",
  appId: "1:801243583431:web:1656ff7c2c7647f2767fe2",
  measurementId: "G-PS5KETM9T2"
} : {
  apiKey: "AIzaSyBP4Uo67HFV33eZlKyz6H6sfCIjCernIK8",
  authDomain: "smart-inventory-1f586.firebaseapp.com",
  databaseURL: "https://smart-inventory-1f586.firebaseio.com",
  projectId: "smart-inventory-1f586",
  storageBucket: "smart-inventory-1f586.appspot.com",
  messagingSenderId: "801243583431",
  appId: "1:801243583431:web:1656ff7c2c7647f2767fe2",
  measurementId: "G-PS5KETM9T2"
};
